var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusZoomIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.3885 2C17.6968 2 22 6.20819 22 11.3993C22 16.5903 17.6968 20.7985 12.3885 20.7985C10.1181 20.7985 8.03162 20.0287 6.38702 18.7415L3.26295 21.7886L3.17983 21.8586C2.88977 22.0685 2.47858 22.0446 2.21612 21.7873C1.92743 21.5043 1.92804 21.0459 2.21749 20.7636L5.30482 17.7523C3.73506 16.0794 2.77692 13.8487 2.77692 11.3993C2.77692 6.20819 7.08015 2 12.3885 2ZM12.3885 3.44774C7.89777 3.44774 4.25735 7.00776 4.25735 11.3993C4.25735 15.7908 7.89777 19.3508 12.3885 19.3508C16.8791 19.3508 20.5196 15.7908 20.5196 11.3993C20.5196 7.00776 16.8791 3.44774 12.3885 3.44774Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.6493 8.7C11.6493 8.34101 11.9404 8.05 12.2993 8.05C12.6583 8.05 12.9493 8.34101 12.9493 8.7V11.0501H15.3C15.659 11.0501 15.95 11.3411 15.95 11.7001C15.95 12.0591 15.659 12.3501 15.3 12.3501H12.9493V14.7018C12.9493 15.0608 12.6583 15.3518 12.2993 15.3518C11.9404 15.3518 11.6493 15.0608 11.6493 14.7018V12.3501H9.29823C8.93925 12.3501 8.64824 12.0591 8.64824 11.7001C8.64824 11.3411 8.93925 11.0501 9.29823 11.0501H11.6493V8.7Z",
    fill: "black",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusZoomIconV2);
export default __webpack_public_path__ + "static/media/plus_zoom_icon_v2.eb8177e6a5134781bff510785b183b8d.svg";
export { ForwardRef as ReactComponent };